import api, { getStorageUrl } from './api';

const PRINTED_COVER_PRICE_PKR = 1500;

const formatIssue = (issue) => ({
  id: issue?.id,
  title: issue?.title,
  slug: issue?.slug,
  volume: issue?.volume,
  issue_no: issue?.issue_no,
  publication_date: issue?.publication_date,
  month_year: issue?.month_year,
  cover_image_url: getStorageUrl(issue?.cover_image),
  cover_image: issue?.cover_image,
  pdf_file_url: getStorageUrl(issue?.pdf_file),
  pdf_file: issue?.pdf_file,
  digital_price_pkr: issue?.digital_price_pkr,
  physical_price_pkr: PRINTED_COVER_PRICE_PKR,
  printed_cover_price_pkr: PRINTED_COVER_PRICE_PKR,
  original_physical_price_pkr: issue?.physical_price_pkr,
  is_physical_available: true,
  is_digital_free: issue?.is_digital_free ?? false,
  preview_pages_count: issue?.preview_pages_count,
  description: issue?.description,
  editor: issue?.editor,
  seo_title: issue?.seo_title,
  seo_description: issue?.seo_description,
  seo_keywords: issue?.seo_keywords,
  status: issue?.status,
  created_by: issue?.created_by,
  created_at: issue?.created_at,
  updated_at: issue?.updated_at,
});

export const magazineApi = {
  getIssues: (params = {}) => api.get('/magazine-issues', { params }),
  getPublishedIssues: async (params = {}) => {
    const r = await api.get('/magazines', { params });
    const list = Array.isArray(r?.data?.data) ? r.data.data : Array.isArray(r?.data) ? r.data : [];
    return { ...(r || {}), data: { ...(r?.data || {}), data_formatted: list.map(formatIssue) } };
  },
  getPublishedBySlug: async (slug) => {
    const r = await api.get(`/magazines/${slug}`);
    const raw = r?.data?.magazine_issue || r?.data?.data || r?.data;
    if (!raw || !raw.id) return { ...(r || {}), data: { ...(r?.data || {}), data_formatted: null, magazine_issue: raw, data: raw } };
    const formatted = formatIssue(raw);
    return { ...(r || {}), data: { ...(r?.data || {}), data: formatted, data_formatted: formatted } };
  },
  getIssue: (id) => api.get(`/magazine-issues/${id}`),

  createIssue: (formData, config = {}) =>
    api.post('/magazine-issues', formData, {
      onUploadProgress: config.onUploadProgress,
      timeout: 10 * 60 * 1000,
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    }),

  updateIssue: (id, formData, config = {}) =>
    api.post(`/magazine-issues/${id}`, formData, {
      onUploadProgress: config.onUploadProgress,
      timeout: 10 * 60 * 1000,
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    }),

  deleteIssue: (id) => api.delete(`/magazine-issues/${id}`),

  formatIssue,
};
